import { render, staticRenderFns } from "./login-test.vue?vue&type=template&id=70700482&scoped=true"
import script from "./login-test.vue?vue&type=script&lang=ts"
export * from "./login-test.vue?vue&type=script&lang=ts"
import style0 from "./login-test.vue?vue&type=style&index=0&id=70700482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70700482",
  null
  
)

export default component.exports